import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { LeadsService } from 'src/app/_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DentalService } from 'src/app/_service/dental.service';
declare var $: any;

@Component({
  selector: 'app-update-ods-scan-logs',
  templateUrl: './update-ods-scan-logs.component.html',
  styleUrls: ['./update-ods-scan-logs.component.css']
})
export class UpdateOdsScanLogsComponent implements OnInit {
  @ViewChild('planUploadFile') planUploadElement: ElementRef;
  odsScanForm: FormGroup; submitted = false; loading: boolean = false; scanId: any; treatments = []; treatments_copy = [];
  dataLoaded: boolean = false; allUploads = []; s3url = ''; myrole: string; appointment_type: any;new_scan:any;trust_align:any;send_download_type:any='';type_validator_drop=false; email_loading: boolean = false;
  nodata: boolean = false;
  placements = ['left'];
  popoverTitle = 'Are you sure?';
  popoverMessage = 'Are you really <b>sure</b> you want to do this?';
  confirmText = 'Yes <i class="fas fa-check"></i>';
  cancelText = 'No <i class="fas fa-times"></i>';
  confirmClicked = false;
  cancelClicked = false;
  fileDeletingLoader: boolean = false;

  constructor(private dentalapi: DentalService, public router: Router, private formBuilder: FormBuilder, private sharedapi: SharedService, public leadapi: LeadsService, private route: ActivatedRoute) {
    this.odsScanForm = this.formBuilder.group({
      'patient_name': [null],
      'patient_age': [null],
      'gender': [null],
      'treatment_id': [null],
      'appointment_type': [null],
      'lead_id': [null],
      'document': [null],
      'position': [null],
      'plan_type': [null],
      'scan_book_id': [null],
      'upper_aligners': [null],
      'lower_aligners': [null],
      'pre_treatment_procedure': [false],
      'pre_treatment_procedure_remarks': [null],
      'other_information': [null]
    });


  }
  ngOnInit(): void {
    this.scanId = this.route.snapshot.paramMap.get("scan_id");
    this.s3url = localStorage.getItem('s3url');
    this.myrole = localStorage.getItem('role');
    this.getTreatment();
    if (this.scanId) {
      this.patchOdsScanData();
    }
  }

  get f() { return this.odsScanForm.controls; }

  async updateOdsScanForm() {
    // console.log(this.odsScanForm.value);return
    this.submitted = true;
    this.loading = true;
    if (this.odsScanForm.invalid) {
      this.loading = false;
      return;
    }
    this.odsScanForm.value.id = parseInt(this.scanId);
    await this.dentalapi.uploadPlanData(this.odsScanForm.value).subscribe((data: any) => {
      this.submitted = false;
      this.loading = false;
      if (data.status) {
        this.patchOdsScanData();
        this.sharedapi.presentToast(data.msg);
        this.planUploadElement.nativeElement.value = "";
        this.odsScanForm.patchValue({
          'position': '',
          'plan_type':''
        });


      }
      else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }

  async getTreatment() {
    await this.leadapi.getTreatments().subscribe((data: any) => {
      if (data.status) {
        this.treatments = data.data;
        this.treatments_copy = this.treatments;
      } else {
        this.treatments = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  setSearchValue(type) {
    if (type == 'treatment') {
      $("#treatmentSearch").val('');
      $("#treatmentSearch").focus();
      this.treatments = this.treatments_copy;
    }
  }

  searchOnSelect(searchtText: string, type) {
    if (type == 'treatment') {
      this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
    }
  }

  async patchOdsScanData() {
    this.dataLoaded = false;
    let qString = '';
    await this.dentalapi.getUpdateOdsDataForLab(this.scanId, qString).subscribe((response: any) => {
      if (response.status) {
        this.dataLoaded = true;

        this.new_scan = response.new_scan;
        this.trust_align = response.trust_align;
        // console.log(this.type.length);
        this.allUploads = response.scanBookOdsDocs;
        this.odsScanForm.patchValue({
          'patient_name': response.data.lead_name,
          'patient_age': response.data.patient_age,
          'gender': response.data.gender,
          'treatment_id': response.data.treatment_id,
          'appointment_type': response.data.appointment_type,
          'lead_id': response.data.lead_id,
          'scan_book_id': response.data.id,
          'upper_aligners': response.data.upper_aligners,
          'lower_aligners': response.data.lower_aligners,
          'pre_treatment_procedure': (response.data.pre_treatment_procedure == 'true') ? true : '',
          'pre_treatment_procedure_remarks': response.data.pre_treatment_procedure_remarks,
          'other_information': response.data.other_information
        });
      }else{
        this.dataLoaded = true;
        this.nodata = true;
        
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  selectfile(event) {
    const file = (event.target as HTMLInputElement).files[0];
    this.odsScanForm.patchValue({
      document: file
    });

  }


  removeFile(fileId) {
    this.fileDeletingLoader = true;
    this.dentalapi.deleteplanFiles(fileId).subscribe((data: any) => {
      this.fileDeletingLoader = false;
      if (data.status) {
        this.patchOdsScanData();
      } else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  validate_type(type_id)
  {
    this.loading = true;
    if(this.send_download_type)
    {
      this.type_validator_drop = false;
      if(type_id==1)
      {
        this.loading = false;
        /****Code for Download PDF****** */
        /* this.dentalapi.download_plan_pdf(this.send_download_type, this.scanId); */
      } 
      else if (type_id==2)
      {
        this.email_loading = true;
        /****Code for Send PDF Plan through HTML****** */
        /* this.dentalapi.sendPdfPlanEmail(this.send_download_type, this.scanId).subscribe((data: any) => {
          this.loading = false;
          this.email_loading = false;
          this.sharedapi.presentToast(data.msg);
        }, error => {
          this.sharedapi.checkError(error);
        }); */
      }
    }
    else
    {
      this.loading = false;
      this.type_validator_drop = true;
    }
    
  }
}
